import styled from 'styled-components';
import { StyledBuildingPaymentWrapper } from './BuildingPayment.styled';
import { colors } from '../../common/ui/globalColors';
import { fonts } from '../../common/ui/globalFonts';

export const StyledTenantDetailsWrapper = styled(StyledBuildingPaymentWrapper)`
    .page-title {
        color: ${({ bankInfo }) => bankInfo ? colors.textColors.white : colors.textColors.black};

        .building-address {
            color: ${({ bankInfo }) => bankInfo ? colors.textColors.white : 'var(--bllink-purple)'};
            font-size: ${({ bankInfo }) => bankInfo ? '40px' : '64px'};
        }
    }

    .back-btn {
        position: absolute;
        top: -40px;
        right: ${({ ltr }) => ltr ? '' : '20px'};
        left: ${({ ltr }) => ltr ? '20px' : ''};
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 14px;
        font-weight: 700;
        width: fit-content;
    
        img {
          transform: ${({ ltr }) => ltr ? 'rotate(0deg)' : 'rotate(180deg)'};
        }
      
        &.covered {
          top: -20px;
        }
      }

    .insurance-top {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-family: var(--bllink-font-primary);
        font-weight: 700;
        max-width: 1100px;
        text-align: center;
        margin-top: -50px;

        .header {
            font-size: 40px;
            line-height: 98px;
            color: ${colors.primaryColors.bllinkBlue};
        }

        .subheader {
            font-size: 35px;
            line-height: 80px;
            color: ${colors.textColors.black};
        }
    }

    position: relative;
    margin-bottom: 70px;

    .close-btn {
        height: 20px;
        font-weight: 300;
        font-size: 36px;
        cursor: pointer;
        position: absolute;
        top: -50px;
        right: 20px;
    }

    .close-btn.cross {
        color: ${colors.textColors.white};
        top: -20px;
    }

    .credit-card-and-actions-block {     
        form {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            grid-template-rows: 1fr 1fr 1fr 2fr;
            gap: 30px;

            .bllink-input-border, textarea {
                background: #F3F1FF;
                border-radius: 10px;
                border: none;
                font-size: 18px;
                font-weight: 700;
                color: #373647;
            }

            .label {
                margin-bottom: 12px;
                text-align: start;
                width: 100%;
            }

            .error {
                position: absolute;
            }

            .full-width {
                grid-column: 1 / -1;

                .text-area {
                    display: flex;
                    flex-direction: column;
                    width: 100%;

                    textarea {
                        resize: none;
                        outline: none;
                        padding: 10px;
                    }
                }
            }

            .checkboxes {
                display: flex;
                flex-direction: column;
                text-align: start;

                .check {
                    display: flex;
                    align-items: center;
                    gap: 7px;
                }

                .icon-wrap {
                    width: 16px !important;
                    height: 16px !important;
                    border-radius: 2px !important;

                    img {
                        width: 10px !important;
                    }
                }
            }

            .app-btn {
                width: 200px;
                justify-self: flex-end;

                .arrow {
                    transform: ${({ ltr }) => ltr ? 'rotate(180deg)' : 'rotate(0deg)'};
                }
            }
        }
    }

    @media screen and (max-width: 768px) {
        margin-top: ${({ bankInfo }) => bankInfo ? '30px' : ''};

        .back-btn {
            right: ${({ ltr }) => ltr ? '' : '20px'};
            left: ${({ ltr }) => ltr ? '20px' : ''};
            top: -40px;
            &.covered {
              top: 0px;
            }
        }
      
        .page-title {
            .building-address {
                font-size: ${({ bankInfo }) => bankInfo ? '20px' : '32px'};
                line-height: ${({ bankInfo }) => bankInfo ? '21px' : '33px'};
                margin-top: ${({ bankInfo }) => bankInfo ? '12px' : ''};
            }
        }

        .insurance-top {
            max-width: 290px;

            img {
                width: 60px;
            }
            
            .header {
                font-size: 34px;
                line-height: 39px;
                margin: 7px 0 10px;
            }
    
            .subheader {
                font-size: 20px;
                line-height: 26px;
            }
        }

        .credit-card-and-actions-block { 
            font-family: ${fonts.defaultFontFamily};
                  
            form {
                display: grid;
                grid-template-columns: 1fr;
                grid-template-rows: 1fr 1fr 1fr 1fr 1fr 2fr 1fr 1fr;
                gap: 20px;

                .app-btn {
                    width: 100%;
                }
            }
        }
    }
`

